import React, { useContext, useState } from 'react';
import Button from 'react-bootstrap/Button';
import Modal from 'react-bootstrap/Modal';
import blogFetch from '../../../../axios/config';
import Context from '../../../../context/Context'
import toast from "react-hot-toast";
import language from '../../../../nls/language.json';

export const ConfirmModal = (
  { show,
    handleClose,
    handleConfirm,
    wagon,
    partsByFurnace,
    selectedWagon,
    setIsEdit,
    INITIAL_VALUE,
    reset,
    setShowConfirmModal,
  }) => {
  const {
    selectedCountry,
    selectedFurnace,
    getConfirmedWagon,
    getPartsByFurnace,
  } = useContext(Context);


  const checkArray = (data, array, wagon) => {
    const parts = partsByFurnace.map((item) => item.pecasSetor.ordem_Serial)
    data.wagon.forEach((z) => {
      if (array.every((e) => e.Ordem_Serial !== z.ordem_Serial)) {
        array.push({
          Ordem_Serial: z.ordem_Serial,
          Sugerida: wagon.some((d) => z.ordem_Serial === d.ordem_Serial),
          Ativo: true,
          Posicao_Lista: parts.indexOf(z.ordem_Serial) + 1,
        })
      } else {
        const alterAtivo = array.find((f) => f.Ordem_Serial === z.ordem_Serial)
        alterAtivo.Ativo = true
      }
    })

    return array;
  };

  const getMatricula = () => {
    const user = JSON.parse(localStorage.getItem('user'));
    return user?.user_SAPMatricula;
  };

  const putObjWagon = async (data) => {
    try {
      await blogFetch.put(`/ISAGA_VagoesFornos`, data);
      toast.success("Vagão alterada com sucesso", {
        duration: 4000
      })
    } catch {
      toast.error("Erro ao alterar o vagão", {
        duration: 4000
      })
      console.error("Error");
    }
    getConfirmedWagon()
  }

  const postObjWagon = async (data) => {
    try {
      await blogFetch.post(`/ISAGA_VagoesFornos`, data);
      toast.success(language[selectedCountry.name].PainelFornos.notification.successAddWagon, {
        duration: 4000
      })
    } catch {
      toast.error(language[selectedCountry.name].PainelFornos.notification.errorAddWagon, {
        duration: 4000
      })
      console.error("Error");
    }
    getConfirmedWagon();
    getPartsByFurnace(selectedFurnace);
  };

  const handleSaveWagon = (wagonData) => {
    // const checkWagon = wagonData.find((item) => item.tipoCombinacaoPeca.tipoComb_Key === selectedWagon.tipoCombinacaoPeca.tipoComb_Key)
    // if (!checkWagon.wagon.length) {
    //   toast.error(language[selectedCountry.name].PainelFornos.notification.errorAdd, {
    //     duration: 4000
    //   })
    //   return
    // }
    const parts = partsByFurnace.map((item) => item.pecasSetor.ordem_Serial)
    let array = []
    selectedWagon.wagon.forEach((a) => {
      array.push({
        Ordem_Serial: a.ordem_Serial,
        Sugerida: true,
        Ativo: wagonData.some((b) => {
          if (!!b.wagonInfo?.vagao_Key && b.wagonInfo?.vagao_Key === selectedWagon.wagonInfo?.vgao_Key)
            return b.wagon.some((c) => c.ordem_Serial === a.ordem_Serial)
          else if (b.tipoCombinacaoPeca?.tipoComb_Key === selectedWagon.tipoCombinacaoPeca?.tipoComb_Key)
            return b.wagon.some((c) => c.ordem_Serial === a.ordem_Serial)

          return false
        }),
        Posicao_Lista: parts.indexOf(a.ordem_Serial) + 1
      })
    })
    wagonData.forEach((x) => {
      if (!!x.wagonInfo?.vagao_Key && x.wagonInfo?.vagao_Key === selectedWagon.wagonInfo?.vagao_Key)
        array = checkArray(x, array, selectedWagon.wagon);

      else if (!x.wagonInfo?.vagao_Key && x.tipoCombinacaoPeca.tipoComb_Key === selectedWagon.tipoCombinacaoPeca.tipoComb_Key)
        array = checkArray(x, array, selectedWagon.wagon);
    });
    const nroMatricula = getMatricula();
    selectedWagon.wagonInfo?.vagao_Key
      ? putObjWagon({
        vagao_Key: selectedWagon?.wagonInfo?.vagao_Key,
        pieces: array,
        Nro_Matricula: nroMatricula,
      })
      : postObjWagon({
        TipoComb_Key: selectedWagon.tipoCombinacaoPeca.tipoComb_Key,
        pieces: array,
        Nro_Matricula: nroMatricula,
      })
    setIsEdit(INITIAL_VALUE)
    reset()
    setShowConfirmModal(false);
  };

  const handleModalClose = () => {
    setShowConfirmModal(false);
    handleClose();
  };

  return <Modal show={show} onHide={handleModalClose}>
    <Modal.Header closeButton>
      <Modal.Title>Confirmar Ação</Modal.Title>
    </Modal.Header>
    <Modal.Body>Tem certeza que deseja confirmar?</Modal.Body>
    <Modal.Footer>
      <Button variant="secondary" onClick={handleModalClose}>
        Não
      </Button>
      <Button variant="primary" onClick={() => handleSaveWagon(wagon)}>
        Sim
      </Button>
    </Modal.Footer>
  </Modal>

}

